import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Function area feature parameters */
export interface FunctionAreaParams {
  /** Reference to parent function element */
  of: string;
  /** Start x-coordinate for the area */
  xStart: number;
  /** End x-coordinate for the area */
  xEnd: number;
  /** Whether to show signed areas (positive green, negative red) */
  signed?: boolean;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** Default parameter values (xStart and xEnd must be provided) */
export const FUNCTION_AREA_DEFAULT_PARAMS: Omit<FunctionAreaParams, 'of' | 'xStart' | 'xEnd'> = {
  signed: false,
};

/**
 * Default theme for function area feature.
 * Indigo for unsigned areas, green/red for signed areas.
 *
 * Structure:
 * - polygon: Fill style for the area
 * - line: Style for boundary lines at xStart and xEnd
 * - point: Style for points at the boundary line endpoints
 * - subparts.positive: Style for positive regions (f(x) > 0)
 * - subparts.negative: Style for negative regions (f(x) < 0)
 */
export const FUNCTION_AREA_DEFAULTS: FeatureStyleNode = {
  polygon: {
    fillColor: 'indigo',
    fillOpacity: 0.3,
    strokeWidth: 0,
  },
  line: {
    color: 'indigo',
    dash: 3,
    strokeWidth: 2,
  },
  point: {
    color: 'indigo',
    visible: false,
  },
  subparts: {
    positive: {
      polygon: { fillColor: 'green' },
    },
    negative: {
      polygon: { fillColor: 'red' },
    },
  },
};
